module.exports = __webpack_public_path__ + "img/m.a526d3be.jpg";